<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <app-modal-back-button [priority]="9999" (activated)="onDismiss()"></app-modal-back-button>
    </ion-buttons>

    <ion-title> Edit amount to pay now </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-row class="ion-justify-content-left">
    <div class="title">
      <div class="content">{{ paymentTitle }}</div>
      <hr />
    </div>
  </ion-row>
  <ion-row class="ion-justify-content-left toPay">
    <div class="totalAmount">
      <div class="content">
        <span class="legend">Still to Pay</span>

        <span class="value">
          <span class="pounds">£{{ balancePounds }}</span>
          <span class="pences">.{{ balancePence }}</span>
        </span>
      </div>

      <hr />
    </div>
  </ion-row>
  @if (vm$ | async; as vm) {
    <form [formGroup]="form" #ngForm="ngForm" (ngSubmit)="onSubmit()">
      <ion-row class="ion-justify-content-center">
        <ion-item class="amount-container item-label-floating" lines="none">
          <div class="amount-input">
            <ion-label>Enter the amount to pay now</ion-label>
            <ion-input #amountInput type="number" inputmode="decimal" formControlName="toPay"></ion-input>
          </div>
        </ion-item>
      </ion-row>
      <ion-row class="ion-justify-content-center error-container">
        @if (!toPay.valid && !toPay.pristine) {
          <ion-item lines="none">
            <div>
              @if (toPay.errors.required || toPay.errors.pattern) {
                <p class="errorText ion-text-center">
                  Please enter an amount in a valid format. e.g. 10, or 10.00.
                </p>
              }
              @if (toPay.errors.remainingAmount) {
                <p class="errorText ion-text-center">
                  The amount left to pay must be at least £1.00
                </p>
              }
              @if (toPay.errors.max) {
                <p class="errorText ion-text-center">
                  The maximum you can enter is the amount still to pay.
                </p>
              }
              @if (toPay.errors.min) {
                <p class="errorText ion-text-center">
                  Please enter an amount greater than the minimum.
                </p>
              }
            </div>
          </ion-item>
        }
        @if (vm.intentError) {
          <ion-item lines="none">
            <p class="errorText ion-text-center">{{ vm.intentError }}</p>
          </ion-item>
        }
      </ion-row>
      <ion-item class="minimum-payment-example-container" lines="none">
        <p class="minimum-amount exampleText">£{{ formattedMinimum }} minimum</p>
      </ion-item>
      <ion-row class="submit-container ion-justify-content-center">
        @if (!vm.working) {
          <ion-button [disabled]="!form.valid" color="secondary" type="submit" class="submitButton">
            Apply
          </ion-button>
        }
        @if (vm.working) {
          <ion-button disabled color="secondary" type="button" class="submitButton">
            <ion-spinner name="crescent"></ion-spinner>
          </ion-button>
        }
      </ion-row>
    </form>
  }
</ion-content>
